// @ts-nocheck
import { useState, useEffect } from "react";
import { Button, IconButton, Tooltip, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import PropTypes from "prop-types";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

export default function CopyButton({
  value,
  variant = "long",
  timeout = 1500,
  tooltip = "Copy",
  copyLabel = "Copy",
  copiedLabel = "Copied",
  disabled = false,
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), timeout);
    return () => clearTimeout(timer);
  }, [copied, timeout]);

  const handleCopy = async (e) => {
    if (copied || disabled || !e) return;

    e?.preventDefault();
    e?.stopPropagation();

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const tooltipTitle = Array.isArray(tooltip)
    ? copied
      ? (tooltip[1] ?? "Copied")
      : (tooltip[0] ?? "Copy")
    : copied
      ? "Copied"
      : tooltip;

  const icon = copied ? (
    <CheckIcon
      sx={{
        cursor: "pointer",
        color: getCssVariableHandler({
          variableName: "--primary-green-shade2-hex",
        }),
        fontSize: "1.15rem",
      }}
    />
  ) : (
    <ContentCopyIcon
      sx={{
        cursor: "pointer",
        color: "white",
        fontSize: "1.15rem",
      }}
    />
  );

  const commonProps = {
    onMouseDown: (e) => {
      e.preventDefault();
      e.stopPropagation();
    },
    onClick: handleCopy,
    disabled: disabled || copied,
    "aria-live": "polite",
    sx: { display: "inline-flex" },
  };

  if (!value) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle} arrow>
      {variant === "short" ? (
        <IconButton size="small" {...commonProps}>
          {icon}
        </IconButton>
      ) : (
        <Button size="small" startIcon={icon} {...commonProps} sx={{ px: 1 }}>
          {copied ? copiedLabel : copyLabel}
        </Button>
      )}
    </Tooltip>
  );
}
CopyButton.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.oneOf(["long", "short"]),
  timeout: PropTypes.number,
  tooltip: PropTypes.string,
  copyLabel: PropTypes.string,
  copiedLabel: PropTypes.string,
  disabled: PropTypes.bool,
};